module.exports = __webpack_public_path__ + "static/media/email-icon.a11ef90b.svg";